// Kinio KMS 操作台的 mock 開關（k1-wbs M1-14：kmgr 的 M1-10 事故、M1-11 輪值表還在做，前端先接 mock）。
//
// 只在 dev / test（hasDevFeatures）才可能打開；prod 一律關。打開的方式（先到先用）：
//   1. 瀏覽器 localStorage `vms.kmgr.mock` = `off`（關）/ `missing`（只 mock 還沒有的端點）/ `all`（連已有的端點也 mock，kmgr 沒部署時看畫面用）
//   2. 品牌 / plane 設定 features.kmgr_mock = true → `missing`
//   3. 都沒有 → 關（直接打 kmgr；端點不在時那一區顯示「讀不到」）
// 還沒有的端點清單見 api.ts 的 MISSING_ENDPOINTS；kmgr 做好後從清單拿掉即可，畫面不用改。
import { hasDevFeatures, type AppConfig } from '../../lib/appConfig';

export type KmgrMockMode = 'off' | 'missing' | 'all';

export const KMGR_MOCK_KEY = 'vms.kmgr.mock';

export function kmgrMockMode(cfg: Pick<AppConfig, 'env' | 'features'>, stored: string | null = readStored()): KmgrMockMode {
  if (!hasDevFeatures(cfg.env)) return 'off';
  if (stored === 'off' || stored === 'missing' || stored === 'all') return stored;
  if (stored === 'on') return 'missing';
  return cfg.features?.kmgr_mock === true ? 'missing' : 'off';
}

function readStored(): string | null {
  try {
    return localStorage.getItem(KMGR_MOCK_KEY);
  } catch {
    return null;
  }
}
